import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import axios from "axios";

import { request } from '../../../api';
import cancelPieceForm from '../cancel_piece_form';
import ImagePreview from '../../components/edit/ImagePreview';
import ImageDropzone from '../../components/edit/ImageDropzone';

import styles from './vtrg_inner_block.scss';

const VtrgInnerBlockForm  = ({ data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
  blockType
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const blocks = data && data.inner && data.inner.blocks ? data.inner.blocks : [{ type: 'vtrg_inner_block', other: { block_type: "1" } }, { type: 'vtrg_inner_block', other: { block_type: "1" } }];
  const [whichFormShowInnerFirst, setWhichFormShowInnerFirst] = useState(blocks.length > 0 ? parseInt(blocks[0].other.block_type) : null);
  const [whichFormShowInnerSecond, setWhichFormShowInnerSecond] = useState(blocks.length > 1 ? parseInt(blocks[1].other.block_type) : null);
  
  // Выбранные, но ещё не сохранённые изображения подблоков — для превью
  const [selectedImages, setSelectedImages] = useState({});

  const [values, setValues] = useState({
      vitrage_pieces_vtrg_custom_block: {
        block_type: blockType && blockType,
        vtrg_inner_blocks_attributes:  (blocks && blocks.length > 0) ?
            blocks.map((block, key)=> {
              return ({
                // key: {
                  id: block?.other?.id ? block.other.id : '',
                  block_type: block?.other?.block_type ? block.other.block_type : '1',
                  // type: block.type,
                  bg_color: block?.other?.bg_color ? block.other.bg_color : '#000', 
                  block_padding: block.other.block_padding, 
                  // block_margin: block.other.block_margin,
                  vtrg_centered_image_attributes: (((whichFormShowInnerFirst === 2) && (key === 0)) || ((whichFormShowInnerSecond === 2) && (key === 1))) ? {
                    image: block.image && block.image.image ? block.image.image : '',
                    back_color: block.image && block.image.back_color ? block.image.back_color : '', 
                    id: block.image && block.image.id ? block.image.id : ''
                  } : {
                    image: '',
                    back_color: '',
                    id: block.image && block.image.id ? block.image.id : ''
                  },
                  
                  vtrg_video_attributes: (((whichFormShowInnerFirst === 1) && (key === 0)) || ((whichFormShowInnerSecond === 1) && (key === 1))) ? {
                    first_video: block.video && block.video.first_video ? block.video.first_video : '', 
                    first_video_webm: block.video && block.video.first_video_webm ? block.video.first_video_webm : '', 
                    id: block.video && block.video.id ? block.video.id : '', 
                    autoplay: block.video && block.video.autoplay ? block.video.autoplay : ''
                  } : {
                    first_video: '',
                    first_video_webm: '',
                    autoplay: '',
                    id: block.video && block.video.id ? block.video.id : ''
                  },
                  vtrg_custom_html_attributes: (((whichFormShowInnerFirst === 3) && (key === 0)) || ((whichFormShowInnerSecond === 3) && (key === 1))) ? { 
                    body: block.html && block.html.body ? block.html.body : '', 
                    id: block.html && block.html.id ? block.html.id : ''
                  } : {
                    body: '',
                    id: block.html && block.html.id ? block.html.id : ''
                  }
                // }
              })
            }) : {}
            
      },
      kind: pieceType, 
      owner_type: instanceType, 
      owner_id: instanceId,  
      id: data && data.id
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (localData, e) => {
    setDisableBtns(true);
    if (ordn) {
      setActionLoading(ordn);
    }

    // TODO костыль
    //console.log(e.action);
    //console.log(values);
    //console.log(localData);
    Object.keys(localData)
      .filter((key) => key in values)
      .forEach((key) => (localData[key] = values[key]));
   
    // TODO снова костыль
    const dataForm = new FormData();
    // debugger
    const appendArray = (form_data, values, name) => {
      if(!values && name) {
        form_data.append(name, '');
      }
      else {
        if(typeof values == 'object') {
          for(let key in values) {
            if( (typeof values[key] === 'object') && ((key !== 'image') && (key !== 'first_video') && (key !== 'first_video_webm')) ) {
              appendArray(form_data, values[key], name + '[' + key + ']');
            }
            else {
              form_data.append(name + '[' + key + ']', (typeof values[key] !== 'undefined') ? values[key] : '' );
            }
          }
        }
        else {
          form_data.append(name, values);
        }
      }
      return form_data;
    };
    
    appendArray(dataForm, values.vitrage_pieces_vtrg_custom_block, 'vitrage_pieces_vtrg_custom_block');
    dataForm.append('kind', pieceType);
    dataForm.append('owner_type', instanceType);
    dataForm.append('owner_id', instanceId);
    dataForm.append('id', data && data.id ? data.id : '');

    // Object.entries(values).map(([key, value]) => {
    //   // dataForm.set('vtrg_inner_blocks_attributes', JSON.stringify(item[1].vtrg_inner_blocks_attributes));
    //   dataForm.set(key, value);
    // });

    axios
      .post(`${request}/vitrage/pieces/${slot ? slot : "new"}`, 
        dataForm,
        { headers: { 
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*' 
        } }
      )
      .then((response) => {
        if (response.statusText === "OK") {
          setSuccessMsg("Изменения успешно внесены");
          if (!slot && response.data.content) {
            getPieceForm(null);
            afterUpdateVtrgPiece(response.data.content);
          } else {
            afterUpdateVtrgPiece(localData);
          }
        } else {
          setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };
  
  const onError = (errors, e) => {
    console.log(errors);
    setErrorMsg("Произошла ошибка");
  };

  return (
    <div className="vtrg-edit-body">
      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate="novalidate"
        className="vitrage_pieces_vtrg_inner_block_form"
        encType="multipart/form-data"
        action={`${request}/vitrage/pieces/${slot ? slot : "new"}}`}
        accept-charset="UTF-8"
        data-remote="true"
        method="post"
      >
        
      <div className='custom-form vtrg-two-blocks'>
        
      { blocks.map((block, key)=> { 
        return (
          <div className='content_field block_form_style inner-block'>
            <select
                // TODO  this is 
                defaultValue={(block.other && block.other.block_type) ? block.other.block_type : "1" }
                // {...register(`[vtrg_inner_blocks_attributes][${key}][block_type]`, { value: values[key].vtrg_inner_blocks_attributes.block_type })}
                {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][block_type]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].block_type })}
                onChange={e => {
                  if (key === 0) {
                    setWhichFormShowInnerFirst(parseInt(e.target.value))
                  }
                  if (key === 1) {
                    setWhichFormShowInnerSecond(parseInt(e.target.value))
                  }
                  setValues(values => {
                    // debugger
                    if (values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key]) {
                      values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].block_type = parseInt(e.target.value);
                      if (parseInt(e.target.value) === 1) {
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_centered_image_attributes = { image: '', back_color: '', id: ''}
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_custom_html_attributes = { body: '', id: '' }
                      }
  
                      if (parseInt(e.target.value) === 2) {
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_video_attributes = {
                          first_video: '', 
                          first_video_webm: '', 
                          id: '', 
                          autoplay: ''
                        }
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_custom_html_attributes = { 
                          body: '', 
                          id: ''
                        }
                      }
                      if (parseInt(e.target.value) === 3) {
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_centered_image_attributes = {
                          image: '',
                          back_color: '', 
                          id: ''
                        }
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_video_attributes = {
                          first_video: '', 
                          first_video_webm: '', 
                          id: '', 
                          autoplay: ''
                        }
                      }
                    }
                    return values;
                  });
                }}
              >
                <option selected={(((whichFormShowInnerFirst === 1) && (key === 0)) || ((whichFormShowInnerSecond === 1) && (key === 1)))} value="1">Видео</option>
                <option selected={(((whichFormShowInnerFirst === 2) && (key === 0)) || ((whichFormShowInnerSecond === 2) && (key === 1)))} value="2">Фото</option>
                <option selected={(((whichFormShowInnerFirst === 3) && (key === 0)) || ((whichFormShowInnerSecond === 3) && (key === 1)))} value="3">HTML-код</option>
            </select>
            <input
              type="hidden"
              name="[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][id]"
              value={values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].id}
              {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][id]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].id })}
            />
            { (((whichFormShowInnerFirst === 2) && (key === 0)) || ((whichFormShowInnerSecond === 2) && (key === 1))) ? <>
              <fieldset className="inputs">
                <label>Изображение</label>
                <input
                  type="hidden"
                  name="[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][id]"
                  value={values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_centered_image_attributes.id}
                  {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_centered_image_attributes][id]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_centered_image_attributes.id })}
                />
                <ImageDropzone
                  name="image"
                  onChange={(files) => {
                    const file = files[0];
                    setValues(values => {
                      values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_centered_image_attributes.image = file;
                      return values;
                    });
                    setSelectedImages(prev => ({ ...prev, [key]: file }));
                  }}
                />
                <ImagePreview
                  image={selectedImages[key] || block?.image?.image}
                  version={block?.image?.updated_at ? new Date(block.image.updated_at).getTime() : 0}
                />
              </fieldset>
            </> : <></> }
            { 
              ((((whichFormShowInnerFirst === 3) && (key === 0)) || ((whichFormShowInnerSecond === 3) && (key === 1)))) ? <>
              <fieldset className="inputs">
                <label>Код*</label>
              </fieldset>
              <input
                type="hidden"
                name="[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][id]"
                value={values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_custom_html_attributes.id}
                {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_custom_html_attributes][id]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_custom_html_attributes.id })}
              />
              <textarea
                className="vtrg_long_textarea"
                rows="6"
                id="vitrage_pieces_vtrg_custom_html_body"
                required
                name={`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_custom_html_attributes][body]`}
                {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_custom_html_attributes][body]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_custom_html_attributes.body })}
                
                onChange={e => {
                  setValues(values => {
                    values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_custom_html_attributes.body = e.target.value;
                    return values;
                  });
                }}
              >
                {block?.html?.body ? block.html.body : ''}
              </textarea>
            </> : <></> }
            { ((((whichFormShowInnerFirst === 1) && (key === 0)) || ((whichFormShowInnerSecond === 1) && (key === 1)))) ? <>
              <fieldset className="inputs">
                <label>Видео с формате mp4</label>
                <input
                  type="file"
                  name={`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_video_attributes][first_video]`}
                  placeholder="Файл"
                  {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_video_attributes][first_video]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_video_attributes.first_video })}
                  onChange={e => {
                    setValues(values => {
                      values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_video_attributes.first_video  = e.target.files[0];
                      return values;
                    });
                  }}
                />
              </fieldset>
              <fieldset className="inputs">
                <label>Видео в формате webm</label> 
                <input
                  type="file"
                  name={`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_video_attributes][first_video_webm]`}
                  placeholder="Файл"
                  {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][vtrg_video_attributes][first_video_webm]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_video_attributes.first_video_webm })}
                  
                  onChange={e => {
                    setValues(values => {
                      values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].vtrg_video_attributes.first_video_webm = e.target.files[0];
                      return values;
                    });
                  }}
                />
              </fieldset>
            </> : <></> }
              <fieldset className="inputs">
                <label>Отступы в px</label>
                <input
                  type="text"
                  name="block_padding"
                  defaultValue={block.other && block.other.block_padding ? block.other.block_padding : ''}
                  placeholder="0"
                  {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][block_padding]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].block_padding })}
                  
                  onChange={e => {
                    setValues(values => {
                      values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].block_padding = e.target.value;
                      return values;
                    });
                  }}
                />
                <p className='inline-hints'>Отступы задаются в порядке: сверху, справа, снизу, слева</p>
              </fieldset>
              {/* <fieldset className="inputs">
                  <label>Отступ сверху, px</label>
                  <input
                    type="text"
                    name={`[vtrg_inner_blocks_attributes][${key}][block_margin]`}
                    defaultValue={block.other && block.other.block_margin ? block.other.block_margin : ''}
                    placeholder="0"
                    {...register(`[vtrg_inner_blocks_attributes][${key}][block_margin]`, { value: values[key].vtrg_inner_blocks_attributes.block_margin })}
                    onChange={e => {
                      setValues(values => {
                        values[key].vtrg_inner_blocks_attributes.block_margin = e.target.value;
                        return values;
                      });
                    }}
                  />
              </fieldset> */}

              <fieldset className="inputs">
                <label>Цвет фона</label>
                <input
                    type="color"
                    name="bg_color"
                    defaultValue={values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].bg_color}
                    placeholder="например: #FFF"
                    {...register(`[vitrage_pieces_vtrg_custom_block][vtrg_inner_blocks_attributes][${key}][bg_color]`, { value: values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].bg_color })}
                    
                    onChange={ (e) => {
                      setValues(values => {
                        values.vitrage_pieces_vtrg_custom_block.vtrg_inner_blocks_attributes[key].bg_color = e.target.value;
                        return values;
                      });
                    }}
                />
              </fieldset>
          </div>
        )
      })}
      </div>
        <input
          type="hidden"
          name="block_type"
          value={blockType}
          {...register('block_type', { value: blockType })}
        />
        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register('kind', { value: pieceType })}
        />
        <input
          type="hidden"
          name="owner_type"
          value={instanceType}
          {...register('owner_type', { value: instanceType })}
        />
        <input
          type="hidden"
          name="owner_id"
          value={instanceId}
          {...register('owner_id', { value: instanceId })}
        />

        {successMsg && <p className="success-hint">{successMsg}</p>}
        {errorMsg && <p className="error-hint">{errorMsg}</p>}
        {disableBtns && <span className="loading-hint"> Подождите ... </span>}

        <fieldset className={disableBtns ? 'actions_disable' : 'actions'}>
          <input type="submit" />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>

      </form>
    </div>
  );
}

export default VtrgInnerBlockForm;